import { useState } from "react";
import { useTranslation } from "react-i18next";
import { PageProps } from "../../models/routing.model";
import { getSessionStorageUser } from "../../services/session/auth.service";
import { getUserFullName } from "./home.service";
import Worklist from "./worklist/Worklist";
import HomeRail from "./rail/HomeRail";

const Home = (props: PageProps) => {
	const { t } = useTranslation("common");
	const fullName = getUserFullName(getSessionStorageUser());
	const [isRailExpanded, setIsRailExpanded] = useState(true);

	return (
		<div className="row">
			<div className="col-12">
				<h1 className="mt-3">
					{fullName ? t("HOME.GREETING", { name: fullName }) : t("HOME.GREETING_NO_NAME")}
				</h1>

				{/* The worklist column comes FIRST in the DOM so that on narrow screens (col-12
					both) the rail stacks underneath the worklist rather than disappearing — Maria's
					answer #7. */}
				<div className="row home-content">
					<div className={isRailExpanded ? "col-12 col-lg-8" : "col-12 col-lg"}>
						<Worklist />
					</div>
					<div className={isRailExpanded ? "col-12 col-lg-4" : "col-12 col-lg-auto"}>
						<HomeRail
							expanded={isRailExpanded}
							onToggle={setIsRailExpanded}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Home;
